export default [
  {
    // stockDetail被占用了....

    path: "storage/skuStockList",
    name: "SkuStockList",
    component: () => import("../pages/stockdetail/skuStockList"),
    meta: {
      title: "商品库存列表",
    },
  },
  {
    path: "store/lock-store",
    name: "LockStore",
    component: () => import("../pages/stockdetail/LockList"),
    meta: {
      title: "锁定库存商品列表",
    },
  },
  {
    // 达人待入库单
    path: "huole/package_list",
    name: "HuolePackageList",
    component: () => import("../pages/huole/PackageList"),
    meta: {
      title: "达人待入库",
    },
  },

  {
    // 达人待入库单详情
    path: "huole/package_detail/:package_no",
    name: "HuolePackageDetail",
    component: () => import("../pages/huole/PackageDetail"),
    meta: {
      title: "达人待入库明细",
    },
  },

  {
    // 达人结算单
    path: "huole/talent_bill_list",
    name: "TalentBill",
    component: () => import("../pages/huole/TalentBillList"),
    meta: {
      title: "达人结算单",
    },
  },

  {
    // 达人结算单详情
    path: "huole/talent_bill_detail/:talent_bill_id",
    name: "TalentBillDetail",
    component: () => import("../pages/huole/TalentBillDetail"),
    meta: {
      title: "达人结算单详情",
    },
  },

  {
    // 发货商品校验
    path: "stock/goods-inspection",
    name: "StockGoodsInspection",
    component: () => import("../pages/stockdetail/goods-inspection/index.vue"),
    meta: {
      title: "发货商品校验",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/stockDetail.js